/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M1 3.4173a.5.5 0 0 1 .4106-.492L12 1l10.5894 1.9253a.5.5 0 0 1 .4106.492V4.5a.5.5 0 0 1-.5.5h-21a.5.5 0 0 1-.5-.5V3.4173ZM1 20.5a.5.5 0 0 1 .5-.5h21a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-21a.5.5 0 0 1-.5-.5v-2Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.9092 17H9.1274l-.7116-1.9519H4.4934L3.7697 17H2l3.3387-9h2.2197l3.3508 9ZM6.4455 9.6883l-1.3927 3.8033h2.7914L6.4455 9.6883ZM11.7484 8h4.0867l-.0122.0063c.9062 0 1.6359.32 2.1954.9602.5595.6402.8392 1.362.8392 2.1653 0 .8222-.2797 1.5502-.8392 2.1778-.5595.6276-1.3136.9414-2.2562.9414h-2.317V17h-1.6967V8Zm1.6846 4.6883h2.2622l-.0121-.0126c.4439 0 .8027-.1569 1.0825-.4644.2797-.3075.4196-.6653.4196-1.0732 0-.408-.1338-.7657-.4014-1.0732-.2676-.3076-.6021-.4645-1.0095-.4645H13.433v3.0879Z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M20.2668 17H22V8h-1.7332v9Z" />
  </React.Fragment>,
  'MenuAPIGovernanceFilled'
);
